<input type="file" name="{{fuCtrl.uuid}}" id="{{fuCtrl.uuid}}" class="inputfile" />
<label class="btn btn-{{fuCtrl.color || 'primary'}}" for="{{fuCtrl.uuid}}" uib-tooltip="Datei upload"><i class="fa fa-upload" ></i> {{fuCtrl.label || 'Datei hinaufladen'}} ...</label>
